import { render, staticRenderFns } from "./singleSubjectAvg_tea_month_new.vue?vue&type=template&id=0a0b575d&scoped=true&"
import script from "./singleSubjectAvg_tea_month_new.vue?vue&type=script&lang=js&"
export * from "./singleSubjectAvg_tea_month_new.vue?vue&type=script&lang=js&"
import style0 from "./singleSubjectAvg_tea_month_new.vue?vue&type=style&index=0&id=0a0b575d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b575d",
  null
  
)

export default component.exports